import { createSlice } from "@reduxjs/toolkit";

const initialVoucherNewSliceState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  allGames: [],
  detailedCoinSummary: {},
  NameList: [],
  currencyList: [],
  userInfo: {},
  contestForEdit: {},
  // user: [],
  userContestList: [],
  tournamentLength: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const VoucherNewSlice = createSlice({
  name: "voucherNew",
  initialState: initialVoucherNewSliceState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
      state.tournamentLength = 0;
      state.userContestList = [];
    },

    singleNameFetched: (state, action) => {
      state.actionsLoading = false;
      state.userInfo = action.payload?.userInfo;
      state.error = null;
    },
  },
});
